import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import customer from "../../assets/img/sefa-celik.png"
import mockup from "../../assets/img/sefastone-mockup.png"
import OtherCaseStudy from "../../components/other-case"
import detail1 from "../../assets/img/sefastone-detail1.png"
import detail2 from "../../assets/img/sefastone-detail2.png"
import detail3 from "../../assets/img/sefastone-detail3.png"

import eelbeyglu from "../../assets/img/teams/11.jpg"
import serife from "../../assets/img/teams/20.jpg"
import tugce from "../../assets/img/teams/03.png"

import onay from "../../assets/img/teams/23.jpg"



const ReferancesDetail = () => (
    <Layout>
        <SEO title="Sefa Stone Success Story" />
        <div className="referances-detail py60 container">
            <div className="col-md-6 detail-left">
                <b>SUCCESS STORY</b>
                <h1>Sefa Stone</h1>
                <p>Sefa Stone, a marble company founded in the USA with Turkish capital, has grown to become Miami's largest marble company over the years since its establishment. We have been collaborating in digital marketing since 2015 with this firm that exports many different marble varieties, primarily travertine tiles.</p>
                <h2>Challenges</h2>
                <ul>
                    <li>&bull; Appearing on the 2nd page of Google search results due to high competition on target keywords,</li>
                    <li>&bull; Lack of guidance needed for customer order conversion,</li>
                    <li>&bull; Weak brand awareness on social media.</li>
                </ul>

                <h2>Solution</h2>
                <p>We began building a user-friendly website for Sefa Stone. After changing the infrastructure and applying the right design, we prepared informative content for each product. As a result of our ongoing SEO operations with the brand, we started receiving an average of 24,000 organic visitors per month. Since the keywords we targeted directly encourage customer conversion, customer conversions increased by 46% compared to the previous year.</p>
            </div>
            <div className="col-md-6 referances-boxs">
                <div className="boxs">
                    <div className="box">
                        <span>%46</span>
                        <p>More<br />customer conversions</p>
                    </div>
                    <div className="box">
                        <span>%277</span>
                        <p>2-year organic traffic<br />increase.</p>
                    </div>
                </div>
                <div className="provided">
                    <h3>Services Provided</h3>
                    <div className="provided-box">
                        <div className="box">
                            <Link to="/social-media/"></Link>
                            <svg id="instagram-logo" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 61.312 61.312">
                                <path id="Path_36346" data-name="Path 36346" d="M44.392,0H16.92A16.939,16.939,0,0,0,0,16.92V44.392a16.939,16.939,0,0,0,16.92,16.92H44.392a16.939,16.939,0,0,0,16.92-16.92V16.92A16.939,16.939,0,0,0,44.392,0ZM55.872,44.392a11.493,11.493,0,0,1-11.48,11.48H16.92A11.493,11.493,0,0,1,5.44,44.392V16.92A11.493,11.493,0,0,1,16.92,5.44H44.392a11.493,11.493,0,0,1,11.48,11.48V44.392Z" />
                                <path id="Path_36347" data-name="Path 36347" d="M56.767,40.97a15.8,15.8,0,1,0,15.8,15.8A15.816,15.816,0,0,0,56.767,40.97Zm0,26.156A10.358,10.358,0,1,1,67.125,56.768,10.37,10.37,0,0,1,56.767,67.126Z" transform="translate(-26.111 -26.112)" />
                                <path id="Path_36348" data-name="Path 36348" d="M122.91,28.251a3.987,3.987,0,1,0,2.821,1.168A4,4,0,0,0,122.91,28.251Z" transform="translate(-75.793 -18.005)" />
                            </svg>
                            Social Media
                        </div>
                        <div className="box">
                            <Link to="/ui-ux-design/"></Link>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                                <g id="Icons-_-Design-_-Sketch" data-name="Icons-/-Design-/-Sketch" transform="translate(0.015 -0.307)">
                                    <rect id="bound" width="76" height="76" transform="translate(-0.015 0.307)" fill="none" />
                                    <path id="Path-48" d="M13.728,3H58.276L71,18.91H1Z" transform="translate(2.182 6.546)" fillRule="evenodd" opacity="0.3" />
                                    <path id="Path-48-Copy" d="M71,8,36,46.184,1,8Z" transform="translate(2.182 17.456)" fillRule="evenodd" />
                                </g>
                            </svg>
                            UI&amp;UX Design
                        </div>
                        <div className="box">
                            <Link to="/search-engine-optimization/"></Link>
                            <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                                    <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                                    <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                                    <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                                </g>
                            </svg>
                            SEO
                        </div>
                    </div>
                </div>
                <div className="project-details">
                    <h3>Impressum</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Brand Strategist:</li>
                            <li>Digital Marketing Specialist:</li>
                            <li>Google Ads:</li>
                            <li>SEO:</li>
                            <li>Website Development:</li>
                        </ul>
                        <ul>
                            <li><img src={eelbeyglu}  alt="Alaattin Emre Elbeyoğlu" />Alaattin Emre Elbeyoğlu</li>
                            <li>Betül Bayraktar</li>
                            <li><img src={serife} alt="Şerife Aytekin" />Şerife Aytekin</li>
                            <li><img src={tugce} alt="Tuğçe Gör" />Tuğçe Gör</li>
                            <li><img src={onay} alt="Barış Onay" />Barış Onay</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
        <div className="container">
            <div className="testimonial-customer" id="one">
                <p>"We worked with many agencies in the USA. Most of the time our agreements ended after the first year because we didn't see results. With Flatart, we saw a 60% increase in organic traffic within 6 months, and over our 3-year collaboration we achieved very significant results."</p>
                <div className="author">
                    <div>
                        <img src={customer} alt="Sefa Çevik"/>
                    </div>
                    <div className="author-name">
                        Sefa Çevik<br />
                        <span>CEO</span>
                    </div>
                </div>
            </div>

            <div className="site-preview">
                <h2>Sefa Stone Success Story<br/> A Detailed Look</h2>
                <p>First, we designed a website with the right infrastructure for the brand.</p>
                <div className="mockup">
                    <img src={mockup} alt="Sefa Stone website displayed on a laptop screen." />
                </div>
            </div>

            <div className="customer-content">
                <div className="row-img">
                    <img style={{ borderRadius: 10 }} src={detail1} alt="Analytics charts belonging to sefastone.com" />
                    <img style={{ borderRadius: 10, transform: 'translateY(-60px)' }} src={detail2}  alt="Analytics charts belonging to sefastone.com" />
                </div>
                <h2>Search engine optimization efforts.
An indispensable traffic source for global success.</h2>

                <p>The keyword groups that Sefa Stone — a brand for which we provide global SEO and SEM services — targets for marble and travertine carry high competition and therefore also high cost-per-click. In response, through the SEO operations we conducted targeting the same keywords, we created rich content that triggered sales and secured targeted organic traffic.</p>
                <p>For the company's SEO operation, 150 web page content pieces averaging 1,000 words each were produced. A unique content piece was created for each product, covering how to clean it, usage recommendations, and decoration suggestions developed in collaboration with real interior architects. Before the operation, the website was visited by an average of 30 users per day; after the SEO efforts, the number of visitors reached 470 users per day.</p>
                <p>As a result of Off-Page SEO efforts, backlinks were obtained from authoritative sites in the industry. This increased the visibility and authority of the Sefa Stone website in search engines.</p>
                <h2>The most suitable social platform for the target audience: Instagram</h2>
                <p>Sefa Stone's target audience consists of owners of large, detached homes. The most practical way to reach this design-oriented audience that loves marble and travertine is Instagram. Starting from this insight, we implemented a growth and reach-focused social media strategy.</p>
                <img style={{ width: '70%', margin: '30px auto' }} src={detail3}  alt="Analytics charts belonging to sefastone.com" />
            </div>
        </div>


        <OtherCaseStudy />

        <Checkup />
    </Layout >
)

export default ReferancesDetail
